import {
  faFilter,
  faTimes,
  faCalendarAlt,
  faChevronDown
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Col,
  Form,
  Row,
  Button,
  Dropdown,
  OverlayTrigger,
  Tooltip,
  InputGroup
} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import userHelper from 'helpers/userHelper';
import _ from 'lodash';

const NotaryJournalTableHeader = ({
  selectedRowIds = {},
  heading,
  searchString,
  setSearchString,
  filterMonth,
  setFilterMonth,
  onCustomDateRange,
  customDateRange,
  setCustomDateRange
}) => {
  const { subscriptionStatus } = useSelector(state => state.subscription);
  let activeSubscriptions = _.get(subscriptionStatus, 'Active', []);
  const { dataExportMonths } = useSelector(state => state.app);

  return (
    <Row className="flex-between-center">
      {heading && (
        <Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
          <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">{heading}</h5>
        </Col>
      )}
      {activeSubscriptions.length > 0 && (
        <Col xs={8} sm="auto" className="ms-auto text-end ps-0 d-flex">
          <div className="d-flex align-items-center ">
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip>
                  {filterMonth
                    ? `Showing ${filterMonth.title || 'all month'}'s signing(s)`
                    : 'Apply filter by month'}
                </Tooltip>
              }
            >
              <span>
                <FontAwesomeIcon className="text-primary" icon={faFilter} />
              </span>
            </OverlayTrigger>
            {/* <Form.Select size="sm" className='mx-1' aria-label="Bulk actions">
            <option>Bulk Actions</option>
            <option value="refund">Refund</option>
            <option value="delete">Delete</option>
            <option value="archive">Archive</option>
          </Form.Select> */}
            {!customDateRange ? (
              <Flex alignItems={'center'} className="gap-2 ms-2 me-2">
                <Dropdown align="end" className="filter-dropdown">
                  <Dropdown.Toggle
                    variant="outline-primary"
                    size="sm"
                    id="dropdown-menu-align-right"
                  >
                    {filterMonth?.title || 'Filter month'}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="filter-dropdown-menu">
                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                      {_.map(dataExportMonths, m => {
                        return (
                          <Dropdown.Item
                            key={_.uniqueId(filterMonth?.displayKey)}
                            className={
                              filterMonth?.begin === m.begin
                                ? 'text-primary fw-semi-bold active'
                                : ''
                            }
                            onClick={() =>
                              setFilterMonth({
                                ...m,
                                begin: moment(m?.begin).format('MM/DD/YYYY'),
                                end: moment(m?.end).format('MM/DD/YYYY')
                              })
                            }
                            eventKey={m.begin}
                          >
                            {m.title}
                          </Dropdown.Item>
                        );
                      })}
                    </div>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      eventKey="clear"
                      onClick={() => setFilterMonth({})}
                      className={
                        !filterMonth?.title ? 'text-primary fw-semi-bold' : ''
                      }
                    >
                      Show All
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => {
                    // Preserve existing dates if they exist, otherwise set to today
                    if (filterMonth?.begin && filterMonth?.end) {
                      setCustomDateRange(true);
                    } else {
                      setCustomDateRange(true);
                      setFilterMonth({
                        begin: moment(new Date()).format('MM/DD/YYYY'),
                        end: moment(new Date()).format('MM/DD/YYYY')
                      });
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faCalendarAlt} className="me-1" />
                  Custom Date
                </Button>
              </Flex>
            ) : (
              <Flex alignItems={'center'}>
                <InputGroup className="">
                  <Form.Group
                    controlId="journal-range-start"
                    style={{ width: 127 }}
                  >
                    <DatePicker
                      className="form-control"
                      onChange={date =>
                        setFilterMonth({
                          ...filterMonth,
                          begin: moment(date).format('MM/DD/YYYY')
                        })
                      }
                      selected={new Date(moment(filterMonth?.begin))}
                      value={moment(filterMonth?.begin).format('MM/DD/YYYY')}
                      dateFormat="MM/dd/YYYY"
                      // clearButtonElement={() =>{ return null}}
                      // showCloseButton={false} // Added to remove the close button
                    />
                  </Form.Group>
                  <Form.Group
                    controlId="journal-range-end"
                    style={{ width: 127 }}
                  >
                    <DatePicker
                      className="form-control"
                      onChange={date =>
                        setFilterMonth({
                          ...filterMonth,
                          end: moment(date).format('MM/DD/YYYY')
                        })
                      }
                      selected={new Date(moment(filterMonth?.end))}
                      value={moment(filterMonth?.end).format('MM/DD/YYYY')}
                      dateFormat="MM/dd/YYYY"
                    />
                  </Form.Group>
                  <Button
                    variant="outline-primary"
                    onClick={() => onCustomDateRange(true)}
                  >
                    Go
                  </Button>
                  <Button
                    variant="outline-danger"
                    onClick={() => onCustomDateRange(false)}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </Button>
                </InputGroup>
              </Flex>
            )}
          </div>
          {Object.keys(selectedRowIds).length > 0 ? (
            <div className="d-flex">
              <Form.Select size="sm" aria-label="Bulk actions">
                <option>Bulk Actions</option>
                <option value="refund">Refund</option>
                <option value="delete">Delete</option>
                <option value="archive">Archive</option>
              </Form.Select>
              <Button
                type="button"
                variant="falcon-default"
                size="sm"
                className="ms-2"
              >
                Apply
              </Button>
            </div>
          ) : (
            <div id="orders-actions">
              <Flex>
                <Form.Control
                  type="search"
                  size="sm"
                  placeholder="Search..."
                  aria-label="Search"
                  className="search-input p-1 px-3"
                  value={searchString || ''}
                  onChange={({ target }) => {
                    setSearchString(target.value);
                  }}
                />
              </Flex>
              {/*<IconButton
              variant="falcon-default"
              size="sm"
              icon="external-link-alt"
              transform="shrink-3"
            >
              <span className="d-none d-sm-inline-block ms-1">Export</span>
              </IconButton>*/}
            </div>
          )}
        </Col>
      )}
    </Row>
  );
};

NotaryJournalTableHeader.propTypes = {
  selectedRowIds: PropTypes.object
};

export default NotaryJournalTableHeader;
